export default '/static/frontend/ReachDigital/12gobiking/dist/assets/klarna-pay-later-dk-e5bcf8a0.svg'